import { render, staticRenderFns } from "./DrawingMenu.vue?vue&type=template&id=f7d83e7a&"
import script from "./DrawingMenu.vue?vue&type=script&lang=js&"
export * from "./DrawingMenu.vue?vue&type=script&lang=js&"
import style0 from "./DrawingMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VList,VListItem})
